import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { Button } from '@/common/components/Button.tsx'
import { ArrowExitRightCornerIcon } from '@/common/icons/arrows.tsx'
import { useTranslation } from 'react-i18next'

type EligibilityConformationProps = {
  goToNextStep: (meetsAllCriterias: boolean) => void
}

export default function EligibilityConformation({
  goToNextStep,
}: EligibilityConformationProps) {
  const { t } = useTranslation()
  async function handleEligibilityChange() {
    goToNextStep(false)
  }

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{t('external_renewal.eligibility_check.title')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="max-w-xl w-full">
        <div>
          <ul className="list-disc space-y-4 text-lg text-gray-700 list-inside mt-4">
            <li>{t('external_renewal.eligibility_check.eligibility_one')}</li>
            <li>{t('external_renewal.eligibility_check.eligibility_two')}</li>
            <li>{t('external_renewal.eligibility_check.eligibility_three')}</li>
          </ul>
        </div>
        <div className="grow flex flex-col justify-center items-center space-y-8">
          <Button
            className="w-full"
            onClick={handleEligibilityChange}
            type="button"
          >
            Yes
          </Button>
          <Button
            className="w-full"
            onClick={() => {
              goToNextStep(true)
            }}
            type="button"
          >
            No
          </Button>
        </div>
        <div className="bg-yellow-100 text-yellow-700 font-semibold text-center rounded shadow-md py-2 px-8">
          <a
            className="underline"
            href="https://app.acescholarships.org/"
            target="_blank"
            aria-label="Link to ACE Scholarships legacy applicant dashboard"
          >
            {t('external_renewal.eligibility_check.footer_link')}
            <ArrowExitRightCornerIcon className="ml-2" />
          </a>
        </div>
      </FamilyWizardLayout.Content>
    </FamilyWizardLayout>
  )
}
